import {combineReducers, Reducer} from 'redux';

import {ISignupState} from 'Signup/store/types';
import {communicationSignupReducer} from './communication';

export const signupReducer: Reducer<ISignupState> = combineReducers<ISignupState>({
  communications: communicationSignupReducer
});
